import 'semantic-ui-less/semantic.less'
import './main.less';
import { render, toastContainer } from './render';
import { onError, onNote, onSuccess, onWarning } from './components/shared/messages';

export function toastError(error) { onError(error); }
export function toastWarning(error) { onWarning(error); }
export function toastSuccess(title) { onSuccess(title); }
export function toastNote(props) { onNote(props); }
export { render, toastContainer };


if (window.optima) {
    if (!window.optima.commands) {
      window.optima.commands = {};
    }

    if (!window.optima.callbacks){
        window.optima.callbacks = {};
    }

    window.optima.commands.subscribe = (key, callback) => {
         window.optima.callbacks[key] = window.optima.callbacks[key] ? [...window.optima.callbacks[key], callback] : [callback];
    };
    
    window.optima.commands.unsubscribe = (key, func) => {
        if (!func) {
            window.optima.commands.unSubscribeAll(key)
        }
        if (window.optima.callbacks[key]) {
            window.optima.callbacks[key] = window.optima.callbacks[key].filter(callback=>callback.toString() != func.toString())
        }
    };
    
    window.optima.commands.unSubscribeAll = (key) => {
       window.optima.callbacks[key] = null;
    };
  }